import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterByParks } from '../../Components/Public/Filters/FilterByParks.js';
import { FilterAttractions } from '../../Components/Public/Filters/FilterAttractions.js';
import { FilterCategory } from '../../Components/Public/Filters/FilterCategory.js';
import { CarrouselDatas } from '../../Components/Public/Carrousel/CarrouselDatas.js';
import { GetDescription } from '../../Components/Public/Functions/GetDescription.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { Carrousel } from '../../Components/Public/Carrousel/Carrousel.js';
import { BlockLogoParksAndUnivers } from '../../Components/Public/Logos/BlockLogoParksAndUnivers.js';
import { BlockCollection } from '../../Components/Public/Blocks/BlockCollection.js';
import { BlockTitleDate1Link0 } from '../../Components/Public/Blocks/BlockTitleDate1Link0.js';
import { BlockOutlink } from '../../Components/Public/Blocks/BlockOutlink.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';

export const Park = (props) => {
    const { navParks, att, id } = props;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [body, setBody] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const bodyDatas = await fetch(`${backend}/park/body?id=${id}`, GetHeaders(guest));
            const body = await bodyDatas.json();
            setBody(body);
        };
        fetchData();
        ScrollTop();
    }, [backend, id, guest]);
    const park = FilterByParks(att, id);
    const univers = park[0] ? park[0].univers : [];
    const attractions = FilterAttractions('park', att, id);
    const categories = FilterCategory('park', att, id);
    const carrouselDatas = CarrouselDatas('park', univers);
    const carrouselTotal = univers.length;
    const items = GetDescription('park', { body: body, attractions: attractions });
    return (
        <div className="park">
            <Navigation navParks={navParks} />
            <Header />
            <Carrousel label="park" datas={carrouselDatas} total={carrouselTotal} />
            <BreadCrumb label="park" />
            <section className="infos">
                {park.map((item, i) => {
                    return (
                        <div className="bloc-infos" key={i}>
                            <BlockLogoParksAndUnivers label="park" item={item} />
                            <BlockCollection label="park" datas={univers} att={attractions} />
                            <BlockCollection label="categories" datas={categories} att={attractions} />
                            <BlockCollection label="attractions" datas={attractions} />
                        </div>
                    )
                })}
                <div className="description">
                    <BlockTitleDate1Link0 label="park" items={items} />
                    <p>{items.description}</p>
                    <BlockOutlink items={items} />
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}